import { render, staticRenderFns } from "./cardDetail.vue?vue&type=template&id=0c80cc92&"
import script from "./cardDetail.vue?vue&type=script&lang=js&"
export * from "./cardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports